import React from "react";
import { withTranslation } from "react-i18next";

import Page from "../../components/display/Page";
import OpportunitiesList from "../../components/opportunity/List";
import TeamsList from "../../components/team/List";
import Header from "../../components/Header";
import NewOpportunityBtn from "../../components/NewOpportunityBtn";
import TransparentContainer from "../../components/display/TransparentContent";

const Opportunities = ({ t }) => {
  return (
    <Page>
      <TransparentContainer>
        <TeamsList />
      </TransparentContainer>
      <TransparentContainer>
        <Header title={t("global:opportunities")}>
          <NewOpportunityBtn />
        </Header>
        <OpportunitiesList />
      </TransparentContainer>
    </Page>
  );
};

export default withTranslation(["opportunities", "global"])(Opportunities);
